import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"

import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import StepOne from "./StepOne"
import StepTwo from "./StepTwo"
import StepThree from "./StepThree"

const BaseApplication = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [uploadedDocuments, setuploadedDocuments] = useState({})
  const [loading, setloading] = useState(false)

  const [submitted, setsubmitted] = useState(false)
  const [error, seterror] = useState()
  const [applicationDetails, setApplicationDetails] = useState()
  const [editMode, seteditMode] = useState(false)

  // forms
  const [formOne, setformOne] = useState()
  const [formTwo, setformTwo] = useState()

  useEffect(() => {
    setloading(props.loading)
  }, [props.loading])

  useEffect(() => {
    setsubmitted(props.submitted)
  }, [props.submitted])

  useEffect(() => {
    setformOne(props.formOne)
  }, [props.formOne])

  useEffect(() => {
    setformTwo(props.formTwo)
  }, [props.formTwo])

  useEffect(() => {
    seteditMode(props.editMode)
  }, [])

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  // Application details from Child Form (Step 1)
  const stepOneAppDetails = values => {
    //console.log(values)
    setactiveTab(2)
    setApplicationDetails(values)
    //console.log("just retrieved form details from step 1")
  }

  // File attachments retrieved from Child Form (Step 2)
  const stepTwoDocDetails = values => {
    setactiveTab(3)
    //console.log("just retrieved docs from step 2")
    setuploadedDocuments(values)
  }

  const submitApplication = () => {
    props.submit({ docs: uploadedDocuments, formData: applicationDetails })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.title}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Application"
            breadcrumbItem={props.service}
          />

          {editMode ? (
            <>
              <Card>
                <CardTitle className="alert alert-warning">
                  Application Returned
                </CardTitle>
                <CardBody>
                  <h4>{props.comments}</h4>
                </CardBody>
              </Card>
            </>
          ) : null}

          {!submitted ? (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">{props.service}</h4>
                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                //setactiveTab(1)
                              }}
                            >
                              <span className="number">1.</span> Application
                              Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                //setactiveTab(2)
                              }}
                            >
                              <span className="number">2.</span> Document
                              Uploads
                            </NavLink>
                          </NavItem>

                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                //setactiveTab(3)
                              }}
                            >
                              <span className="number">3.</span>
                              Confirm Detail
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <StepOne
                              submit={stepOneAppDetails}
                              toggleTab={toggleTab}
                              formBody={formOne}
                            />
                          </TabPane>
                          <TabPane tabId={2}>
                            <StepTwo
                              submit={stepTwoDocDetails}
                              toggleTab={toggleTab}
                              formBody={formTwo}
                              applicationId={props.applicationId}
                              attachments={props.attachments}
                            />
                          </TabPane>
                          <TabPane tabId={3}>
                            <StepThree
                              submit={submitApplication}
                              toggleTab={toggleTab}
                              loading={loading}
                            />
                          </TabPane>
                        </TabContent>
                      </div>

                      <div></div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Card>
                <CardBody>
                  <div className="row justify-content-center">
                    <Col lg="6">
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Application succesfully submitted</h5>
                        </div>
                        <Link
                          to="/dashboard"
                          className="btn btn-primary"
                          onClick={() => {
                            toggleTab(activeTab + 1)
                          }}
                        >
                          Back
                        </Link>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BaseApplication
